import type { TopicFilters } from '../../types'

interface Props {
  filters: TopicFilters
  onFilterChange: (filters: Partial<TopicFilters>) => void
}

export default function TopicSolvedFilterBar({ filters, onFilterChange }: Props) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <div className="relative flex-1 max-w-xs">
        <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          placeholder="Search resolved topics..."
          value={filters.search || ''}
          onChange={(e) => onFilterChange({ search: e.target.value || null })}
          className="w-full pl-9 pr-3 py-2 border border-stone rounded-md text-sm focus:outline-none focus:border-charcoal focus:ring-2 focus:ring-charcoal/15"
        />
      </div>

      <select
        value={filters.solved_range || 'all_time'}
        onChange={(e) => onFilterChange({ solved_range: e.target.value })}
        className="px-3 py-2 border border-stone rounded-md text-sm text-text-primary"
      >
        <option value="all_time">All Time</option>
        <option value="this_week">This Week</option>
        <option value="this_month">This Month</option>
        <option value="this_quarter">This Quarter</option>
      </select>
    </div>
  )
}
